export default {
    'proforma-invoices': 'الفواتير الأولية',
    'the-proforma-invoice': 'الفاتورة الأولية؟',
    'add-a-proforma-invoice': 'إضافة فاتورة الأولية',
    'proforma-invoice': 'الفاتورة الأولية',
}